import { render } from "./NetworkError.vue?vue&type=template&id=7851b7cc&scoped=true"
import script from "./NetworkError.vue?vue&type=script&lang=js"
export * from "./NetworkError.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-7851b7cc"

export default script